import React, { useState, useEffect } from "react";
import { Typography } from "antd";
import CompanyDetails from "../trom/CompanyDetails";
import PatientDetails from "../trom/PatientDetails";
import Events from "../trom/Events";
import TromWrapper from "../trom/TromWrapper.style";
import ServiceDetails from "../trom/ServiceDetails";
import CompanySignature from "../trom/CompanySignature";
import { getFullName } from "../../../components/util/helpers";
import moment from "moment";
const groupBy = require("lodash/groupBy");

const { Title } = Typography;
const ReportedTromScheduling = (props) => {
  const { record, items } = props;
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const grouped = groupBy(items, (dt) => moment(dt.date).week());
    let final = [];
    Object.keys(grouped).map((key, i) => {
      const sum =
        Math.round(
          (grouped[key].reduce(
            (n, { duration_minutes }) => n + duration_minutes,
            0
          ) /
            60) *
            100
        ) / 100;
      const endOfWeek = moment(grouped[key][0].date).endOf("week");
      const startOfWeek = moment(grouped[key][0].date).startOf("week");
      const startOfOrder = moment(record.effective_from).startOf("day");
      const end =
        moment(record.effective_to) < endOfWeek
          ? moment(record.effective_to)
          : endOfWeek;
      const temp = {
        index: i + 1,
        start: startOfWeek < startOfOrder ? startOfOrder : startOfWeek,
        end: end,
        sum: sum,
        names: grouped[key]
          .map((e) => getFullName(e.employee.surename, e.employee.first_name))
          .filter((v, i, a) => a.indexOf(v) === i)
          .join(", "),
      };
      return final.push(temp);
    });
    setEvents(final);
  }, [items, record]);

  let sorted = record
    ? record.recurrent_work_events.map((obj) => ({
        ...obj,
      }))
    : [];
  sorted.sort((a, b) => a.weekday - b.weekday);

  return (
    <TromWrapper>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          padding: "60px 20px 40px 20px",
        }}
      >
        <div id="trom" className="pdf" dir="rtl">
          <CompanyDetails />
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "0",
            }}
          >
            הודעה על נספח ב' לטרום סיעוד
          </Title>
          <div className="verticalSeperator" />
          <PatientDetails />
          <div className="verticalSeperator" />
          <ServiceDetails record={record} />
          <div className="verticalSeperator" />
          <Events events={events} />
          <div className="verticalSeperator" />
          <CompanySignature />
          <div />
        </div>
      </div>
    </TromWrapper>
  );
};

export default ReportedTromScheduling;
